<template>
  <div :class="['filter-container flex-row', dbOptionHeight]">
    <div class="filter-op">
      <ms-validate ref="validateObserver">
        <menu-wrapper>
          <template #menu-button="{ toggleMenu }">
            <button tabindex="-1" @click="toggleMenu" :class="['btn-filter-operator', dbOptionHeight]">
              <div :class="['icon20', nativeFilterIconClass, dbOptionHeight]" :title="tooltipIcon"></div>
            </button>
          </template>
          <template #menu-content>
            <template v-for="(item, i) in filterOperators" :key="i">
              <menu-item
                class="filter-operator-item"
                :class="item.enumValue === operatorValue ? 'active' : ''"
                @menu-item-click="filterOperatorItemClick(item)"
                :icon="['icon24', item.icon]"
                >{{ item?.enumText }}</menu-item
              >
            </template>
          </template>
        </menu-wrapper>
      </ms-validate>
    </div>
    <div class="filter-value flex">
      <ms-number
        :readOnly="operatorValueReadonly"
        ref="filterInput"
        v-model="filterValue"
        :hasBorder="false"
        @keyup="searchData({ operator: operatorValue, value: filterValue })"
        @blur="filterHeaderHandle({ operator: operatorValue, value: filterValue })"
        :formatType="col.formatType || col.dataFormat"
        @keydown.stop=""
        class="w-full ms-input-filter-value"
      />
    </div>
  </div>
</template>
<script>
import { defineComponent, getCurrentInstance } from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import msValidate from '@/components/validate/MsValidate.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
export default defineComponent({
  extends: msThOptionBase,
  components: {
    msValidate,
    MenuItem,
    MenuWrapper,
  },
  name: 'MsThOptionNumber',
  props: {
    filterIconClass: {
      type: String,
      default: 'ic-filter-equal',
    },
    dbOptionHeight: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const {
      nativeFilterIconClass,
      tooltipIcon,
      operatorValue,
      operatorValueReadonly,
      filterValue,
      filterInput,
      filterHeaderHandle,
      filterOperators,
      removeFilter,
      filterOperatorItemClick,
    } = setup(props, { emit });

    /**
     * Search dữ liệu khi nhập sau 1s
     * NXCHIEN 17.04.2023
     */
    const searchData = ({ operator: operatorValue, value: filterValue }) => {
      clearTimeout(proxy.timeOut);
      proxy.timeOut = setTimeout(() => {
        filterHeaderHandle({ operator: operatorValue, value: filterValue });
      }, 500);
    };

    //Hooks

    return {
      nativeFilterIconClass,
      filterOperators,
      operatorValue,
      filterValue,
      filterInput,
      filterHeaderHandle,
      operatorValueReadonly,
      removeFilter,
      filterOperatorItemClick,
      searchData,
      tooltipIcon,
    };
  },
});
</script>
